import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import Select from "react-select";
import Contact from "./Contact";
import { AddCircle } from "iconsax-react";
import BankDetails from "./BankDetails";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [formData, setFormData] = useState({
    CompanyName: "",
    contectPerson: "",
    email: "",
    primaryNo: "",
    panCardNo: "",
    dealingItem: "",
    isActive: "",
    gstNumber: "",
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [role, setRole] = useState([]);
  const [mobileError, setMobileError] = useState("");
  const [materialLIst, setMaterialLIst] = useState([]);
  const [contactInfo, setContactInfo] = useState([
    {
      gstNumber: "",
      contactNumber: "",
      addressType: "",
      address: "",
      state: "",
      district: "",
      city: "",
      pincode: "",
    },
  ]);
  const [bankDetails, setBankDetails] = useState({
    accountName: "",
    accountNumber: "",
    bankName: "",
    ifscCode: "",
    branch: "",
    cancelCheque: [], // API images
    newCancelCheques: [], // New added images
    isGstVerified: false,
  });

  useEffect(() => {
    console.log(bankDetails);
  }, [bankDetails]);
  useEffect(() => {
    getMateriallist();
  }, []);

  const getMateriallist = () => {
    utils
      .callAPI("get", `/rawmaterial/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setMaterialLIst(res);
        } else {
          setMaterialLIst([]);
        }
      })
      .catch((err) => {
        setMaterialLIst([]);
      });
  };

  const status = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];

  useEffect(() => {
    getRoleList();
  }, []);

  const getRoleList = () => {
    utils
      .callAPI("get", `/role/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setRole([{ id: "", roleName: "Select an option..." }, ...res.result]);
        } else {
          setRole([]);
        }
      })
      .catch((err) => {
        setRole([]);
      });
  };

  const handleInputChange = (e) => {
    const { name, value, type, options } = e.target;

    let newValue = value;

    if (type === "select-multiple") {
      newValue = [...options]
        .filter((option) => option.selected)
        .map((option) => option.value);
    }
    // if (name === "email") {
    //   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //   if (!emailPattern.test(value)) {
    //     setEmailError('Invalid email format')
    //     return;
    //   }
    //   else{
    //     newValue = value;

    //   }

    // }

    // if (name === "primaryNo") {
    //   if (/^\d*$/.test(value)) {
    //     if (value.length > 10) {
    //       setMobileError("Mobile number should be 10 digits");
    //       return;
    //     } else if (value.length === 10) {
    //       setMobileError("");
    //     }
    //     newValue = value;
    //   }
    // }

    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const materialOptions = materialLIst?.result
    ?.filter((material) => material.status === "1")
    .map((material) => ({
      value: material.id,
      label: `${material.product_name} (${material.name})`,
    }));

  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      dealingItem: selectedOptions,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      // if (!mobileError) {
      //   return;
      // }
      setIsSubmit(true);
      // const transformedData = transformContactInfo();
      // console.log(transformedData);
      // console.log(contactInfo);
    }
  };

  const transformContactInfo = () => {
    const transformedData = contactInfo.map((info, index) => ({
      id: info.id ? info.id : 0,
      mobileNo: info.contactNumber,
      gstNo: info.gstNumber,
      addressType: info.addressType,
      address: info.address,
      state: Number(info.state),
      district: Number(info.district),
      city: Number(info.city),
      pincode: Number(info.pincode),
    }));

    return transformedData;
  };

  useEffect(() => {
    if (isSubmit) {
      const transformedData = transformContactInfo();

      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }
      bodyFormData.append("companyName", formData.CompanyName);
      bodyFormData.append("name", formData.contectPerson);
      bodyFormData.append("email", formData.email);
      bodyFormData.append("contactNo", formData.primaryNo);
      bodyFormData.append("panNo", formData.panCardNo);
      const selectedIds = formData.dealingItem
        ?.map((item) => item.value)
        .join(",");
      bodyFormData.append("dealingItemId", selectedIds);

      bodyFormData.append("status", formData.isActive);
      bodyFormData.append("contactDetails", JSON.stringify(transformedData));
      bodyFormData.append("bankAccountName", bankDetails.accountName);
      bodyFormData.append("bankAccountNumber", bankDetails.accountNumber);
      bodyFormData.append("bankName", bankDetails.bankName);
      bodyFormData.append("ifscCode", bankDetails.ifscCode);
      bodyFormData.append("branch", bankDetails.branch);
      bodyFormData.append("gstVerify", "1");
      const availableImages = [];

      bankDetails.newCancelCheques.forEach((file) => {
        bodyFormData.append("image[]", file);
      });
      utils
        .callAPI("post", `/vendors/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (
      props.rowData &&
      Object.keys(props.rowData).length > 0 &&
      materialLIst?.result?.length !== 0
    ) {
      setisEdit(true);
      const selectedItemIds = props.rowData.dealingItemId
        ? props.rowData.dealingItemId.split(",")
        : [];

      const selectedItems = materialLIst?.result
        ?.filter((material) => selectedItemIds.includes(material.id))
        ?.map((material) => ({
          value: material.id,
          label: `${material.product_name} (${material.name})`,
        }));

      setFormData({
        contectPerson: props.rowData.name || "",
        email: props.rowData.email || "",
        primaryNo: props.rowData.contactNo || "",
        gstNumber: props.rowData.gstNo || "",
        panCardNo: props.rowData.panNo || "",
        dealingItem: selectedItems,
        isActive: props.rowData.status || "",
        CompanyName: props.rowData.companyName,
      });
      const apiChequeImages = (props.rowData.cheque_images || []).map(
        (img) => ({
          name: img.chequeImg.split("/").pop(),
          url: img.chequeImg,
          imageId: img.imgId,
          isFromServer: true,
        })
      );

      setBankDetails((prevState) => ({
        ...prevState,
        cancelCheque: apiChequeImages,
        accountName: props?.rowData?.bankAccountName || "",
        bankName: props?.rowData?.bankName || "",
        accountNumber: props?.rowData?.bankAccountNumber || "",
        branch: props?.rowData?.branch || "",
        ifscCode: props?.rowData?.ifscCode || "",
        isGstVerified: props?.rowData?.gstVerify === "1",
      }));
    } else {
      setisEdit(false);
    }
  }, [props.rowData, materialLIst]);

  // Add new contact info section
  const addContactInfo = () => {
    setContactInfo([
      ...contactInfo,
      {
        gstNumber: "",
        contactNumber: "",
        addressType: "",
        address: "",
        state: "",
        district: "",
        city: "",
        pincode: "",
      },
    ]);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header className="border">
          <h4>{isEdit ? "Edit" : "Add"}</h4>

          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <h6 className="mt-2">Vendor Info</h6>
            <hr className="hr-lg mt-1" />
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formName"
                    label="Company Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Company Name"
                      name="CompanyName"
                      value={formData.CompanyName}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formName"
                    label="Contact Person"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Name"
                      name="contectPerson"
                      value={formData.contectPerson}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formEmail"
                    label="Email"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formMobileNo"
                    label="Primary No"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Primary No"
                      name="primaryNo"
                      value={formData.primaryNo}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          handleInputChange(e);
                        }
                      }}
                      required
                      maxLength={10}
                    />
                    <RB.Form.Control.Feedback type="invalid">
                      {mobileError}
                    </RB.Form.Control.Feedback>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formPanCardNo"
                    label="Pan Card No."
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Pan Card No."
                      name="panCardNo"
                      value={formData.panCardNo}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              {/* <RB.Col md={6} className="mb-3">
                <RB.FloatingLabel
                  controlId={`gstNumber`}
                  label="GST Number"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    name="gstNumber"
                    value={formData.gstNumber}
                    onChange={handleInputChange}
                    placeholder="Enter GST Number"
                    required
                  />
                </RB.FloatingLabel>
              </RB.Col> */}
              <RB.Col md={6}>
                <div className="mb-3 mt-3">
                  <RB.FloatingLabel
                    controlId="formDealingItem"
                    className="floating-label-fancy"
                  >
                    <Select
                      isMulti
                      name="dealingItem"
                      options={materialOptions}
                      // className="basic-multi-select"
                      className="bom-productName-select"
                      classNamePrefix="select"
                      placeholder="Dealing items.."
                      value={formData.dealingItem}
                      onChange={handleSelectChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formIsActive"
                    label="Status"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="select"
                      name="isActive"
                      value={formData.isActive}
                      onChange={handleInputChange}
                      required
                    >
                      {status.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </RB.Form.Control>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <BankDetails
              bankDetails={bankDetails}
              setBankDetails={setBankDetails}
            />
            <div className="d-flex justify-content-between align-items-center mt-3">
              <h6 className="mt-2">Contact Info</h6>
              <RB.Button
                className="btn btn-primary me-2"
                onClick={addContactInfo}
                type="button"
              >
                <AddCircle />
              </RB.Button>
            </div>
            <hr className="hr-lg m-1" />

            <Contact
              contactInfo={contactInfo}
              setContactInfo={setContactInfo}
              editData={props?.rowData?.contact_info}
              isEdit={isEdit}
            />

            <RB.Row className="align-items-center">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Save
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
